import axios from 'axios'

const path = '/usuarios'

export function getAllUsuarios () {
  return axios.get(path + '-all')
  .then(response => {
    return response.data
  })
}

export function getUsuarioByEmail (email) {
  return axios.get('/usuarios?email=' + btoa(email))
  .then(response => {
    return response.data
  })
}

export function updateUsuario (id, usuario) {
  return axios.put('/usuarios/' + id, usuario)
  .then(response => {
      return response.data
    })
}

export default {
  getAllUsuarios,
  getUsuarioByEmail,
  updateUsuario,
}
